import React, {useEffect} from 'react';
import {groupBy} from 'lodash';

import DocumentHeader from '../../components/DocumentHeader';
import ResourceCard from '../../components/ResourceCard';
import {useAnalytics} from '../../hooks';

const ResourcesPage = ({resources}) => {
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.resourcesView();
  }, []);

  const grouped = groupBy(resources, (item) => item.category || 'Other');
  const resourcesByCategory = Object.entries(grouped).sort(([a], [b]) => {
    if (a === 'Other') return 1;
    if (b === 'Other') return -1;
    return a.localeCompare(b);
  });

  return (
    <div className="bg-white">
      <DocumentHeader title="Resources" metaDescription="Discover exclusive articles, podcasts, and interviews to help you grow your career." />
      <div className="mx-auto max-w-7xl pt-10 pb-16 px-4 lg:px-8">
        <div className="max-w-3xl mb-10 lg:mb-12">
          <h1 className="text-3xl lg:text-4xl font-bold tracking-tight text-gray-900">Resource Library</h1>
          <p className="mt-3 text-base lg:text-lg text-gray-600 leading-relaxed">
            A library of interviews, podcasts, and career walkthroughs from people working in
            product, engineering, growth, finance, and more. Browse by category to hear how
            others broke into their roles and grew their careers.
          </p>
        </div>
        <div className="w-full flex flex-col gap-10">
          {resourcesByCategory.map(([category, items]) => (
            <div key={category} className="w-full flex flex-col">
              <h2 className="mb-4 text-lg lg:text-xl font-semibold tracking-tight text-gray-900">{category}</h2>
              <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {items.map((item) => (
                  <ResourceCard
                    key={item.id}
                    post={item}
                    badge={item.free ? 'Free' : null}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;
